import React from 'react'
import * as C from "../componentsM/index";

const Giving = () => {
    return (
        <>

            <C.Hero title={"GIVING"} image={"/hero/giving.jpg"} />

            <section className='p-4 md:p-24'>

                <div className='flex flex-col gap-5'>
  
 
                <h1 className="font-semibold">
                The school welcomes all financial support in terms of donations for the development of specific programmes. The programmes and required assistance is listed here for your consideration. Your donation in full or part will benefit all or some student depending on the programme. As this is voluntary, the right to be anonymous or otherwise is with the donor.
                </h1>







                </div>


            </section>

        </>
    )
}

export default Giving